<div>
    <button mat-button outlined (click)="editSubscription()">
        Edit Details
    </button>
    &nbsp;
    <button
        mat-button
        primary
        [disabled]="!updateData || updateData.length <= 0"
        (click)="update()"
    >
        Save Access
    </button>
    <br /><br />
</div>

<kendo-grid [data]="gridView" [selectable]="true" style="height: auto;">
    <kendo-grid-column field="page.name" title="Module" [width]="200"></kendo-grid-column>
    <kendo-grid-column field="page.routerURL" title="URL" [width]="300"></kendo-grid-column>
    <kendo-grid-column field="page.hasPage" title="Enabled">
        <ng-template kendoGridCellTemplate let-record>
            <input
                type="checkbox"
                [(ngModel)]="record.page.hasPage"
                (change)="clickUpdateModule(record.page)"
                [ngModelOptions]="{ standalone: true }"
            />
        </ng-template>
    </kendo-grid-column>

    <div *kendoGridDetailTemplate="let dataItem">
        <kendo-grid [data]="dataItem.pages" [selectable]="true" style="height: auto;">
            <kendo-grid-column
                field="page.name"
                title="Sub Module"
                [width]="200"
            ></kendo-grid-column>
            <kendo-grid-column field="page.routerURL" title="URL" [width]="300"></kendo-grid-column>
            <kendo-grid-column field="page.hasPage" title="Enabled">
                <ng-template kendoGridCellTemplate let-record>
                    <input
                        type="checkbox"
                        [(ngModel)]="record.page.hasPage"
                        (change)="clickUpdateModule(record.page)"
                        [ngModelOptions]="{ standalone: true }"
                    />
                </ng-template>
            </kendo-grid-column>

            <div *kendoGridDetailTemplate="let dataItem2">
                <kendo-grid [data]="dataItem2.pages" [selectable]="true" style="height: auto;">
                    <kendo-grid-column field="name" title="Page" [width]="200"></kendo-grid-column>
                    <kendo-grid-column
                        field="routerURL"
                        title="URL"
                        [width]="300"
                    ></kendo-grid-column>
                    <kendo-grid-column field="page.hasPage" title="Enabled">
                        <ng-template kendoGridCellTemplate let-record2>
                            <input
                                type="checkbox"
                                [(ngModel)]="record2.hasPage"
                                (change)="clickUpdateModule(record2)"
                                [ngModelOptions]="{ standalone: true }"
                            />
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </kendo-grid>
    </div>
</kendo-grid>
